<div class="modal-header" data-test-id="sale-course-cancel-modal">
  <h2 class="modal-title">
    {{ 'saleModule.fullSaleCancel' | translate }}
  </h2>
  <button
    (click)="cancel()"
    attr.aria-label="{{ 'general.close' | translate }}"
    class="btn-close"
    type="button"
  ></button>
</div>

<div class="modal-body">
  <p class="mb-3">
    {{ 'saleModule.courseCancelChoiceDescription' | translate }}
  </p>

  <div class="form-check mb-3">
    <input
      id="sale-course-cancel-mode-future-only"
      type="radio"
      class="form-check-input"
      name="saleCourseCancelMode"
      [value]="courseCancelMode.FUTURE_ONLY"
      data-test-id="sale-course-cancel-mode-future-only"
      [(ngModel)]="selectedMode"
    />
    <label
      class="form-check-label"
      for="sale-course-cancel-mode-future-only"
    >
      {{ 'saleModule.courseCancelModeFutureOnlyTitle' | translate }}
    </label>
    <div class="text-muted small">
      {{ 'saleModule.courseCancelModeFutureOnlyDescription' | translate }}
    </div>
  </div>

  <div class="form-check">
    <input
      id="sale-course-cancel-mode-all"
      type="radio"
      class="form-check-input"
      name="saleCourseCancelMode"
      [value]="courseCancelMode.ALL"
      data-test-id="sale-course-cancel-mode-all"
      [(ngModel)]="selectedMode"
    />
    <label class="form-check-label" for="sale-course-cancel-mode-all">
      {{ 'saleModule.courseCancelModeAllTitle' | translate }}
    </label>
    <div class="text-muted small">
      {{ 'saleModule.courseCancelModeAllDescription' | translate }}
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-white" (click)="cancel()">
    {{ 'general.cancel' | translate }}
  </button>
  <button
    type="button"
    class="btn btn-primary"
    (click)="confirm()"
    data-test-id="sale-course-cancel-confirm"
  >
    {{ 'general.confirm' | translate }}
  </button>
</div>
